/** Real, fixed social profiles — not to be confused with ShareLinks.jsx's generic per-page share intents. */
export const SOCIAL_LINKS = [
  {
    key: "instagram",
    label: "Instagram",
    url: "https://www.instagram.com/tales.wtf",
    icon: (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.6">
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4.3" />
        <circle cx="17" cy="7" r="1" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    key: "discord",
    label: "Discord",
    url: "https://discord.gg/6Xw4fycXBc",
    icon: (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.6">
        <rect x="3" y="6" width="18" height="12" rx="6" />
        <circle cx="9" cy="12" r="1.1" fill="currentColor" stroke="none" />
        <circle cx="15" cy="12" r="1.1" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    key: "tiktok",
    label: "TikTok",
    url: "https://www.tiktok.com/@tales.wtf",
    icon: (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M14 4v10.5a3.5 3.5 0 1 1-3.5-3.5" />
        <path d="M14 4c0 2.5 2 4.5 4.5 4.5" />
      </svg>
    ),
  },
  {
    key: "youtube",
    label: "YouTube",
    url: "https://www.youtube.com/@tales-wtf",
    icon: (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.6">
        <rect x="3" y="6" width="18" height="12" rx="4" />
        <path d="M10.5,9.5 L15.5,12 L10.5,14.5 Z" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    key: "linkedin",
    label: "LinkedIn",
    url: "https://www.linkedin.com/company/talesandlegends",
    icon: (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.6">
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="8.5" cy="8.5" r="1" fill="currentColor" stroke="none" />
        <line x1="8.5" y1="11" x2="8.5" y2="16.5" />
        <line x1="12.5" y1="16.5" x2="12.5" y2="11" />
        <path d="M12.5,13.5 C12.5,11.5 16.5,11.5 16.5,13.5" />
        <line x1="16.5" y1="13.5" x2="16.5" y2="16.5" />
      </svg>
    ),
  },
];
